export const LimangoRoutes = [
  {
    path: '/suedtirol',
    name: 'suedtirol',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Suedtirol.vue'
      ),
    meta: {
      breadcrumb: 'Südtirol',
    },
  },
  {
    path: '/bella-italia',
    name: 'bella-italia',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/BellaItalia.vue'
      ),
    meta: {
      breadcrumb: 'Bella Italia',
    },
  },  
  {
    path: '/deutschland',
    name: 'germany',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Germany.vue'
      ),
    meta: {
      breadcrumb: 'Deutschland',
    },
  },
  {
    path: '/gardasee',
    name: 'gardasee',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Gardasee.vue'
      ),
    meta: {
      breadcrumb: 'Gardasee',
    },
  },
  {
    path: '/chalet',
    name: 'chalet',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Chalet.vue'
      ),
    meta: {
      breadcrumb: 'Chalet',
    },
  },
  {
    path: '/city',
    name: 'city',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/City.vue'
      ),
    meta: {
      breadcrumb: 'City',
    },
  },
  {
    path: '/wellness',
    name: 'wellness',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Wellness.vue'
      ),
    meta: {
      breadcrumb: 'Wellness',
    },
  },
  {
    path: '/wien',
    name: 'vienna',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Vienna.vue'
      ),
    meta: {
      breadcrumb: 'Wien',
    },
  },
  {
    path: '/replerhof',
    name: 'replerhof',
    component: () =>
      import(
        /* webpackChunkName: "lp-limango" */ /* webpackPreload: true */ '../views/Landingpages/Limango/Replerhof.vue'
      ),
    meta: {
      breadcrumb: 'Replerhof',
    },
  },
]
